{
    "Profile_Dwellings_HeatingSystem.heatingSystem": "Heating System",
    "Profile_Dwellings_HeatingSystem.heatingSystemDetails": "Heating System Details",
    "Profile_Dwellings_HeatingSystem.type": "Type",
    "Profile_Dwellings_HeatingSystem.fuelType": "Fuel Type",
    "Profile_Dwellings_HeatingSystem.numberOfChords": "Number of Chords",
    "Profile_Dwellings_HeatingSystem.chimneyType": "Chimney Type",
    "Profile_Dwellings_HeatingSystem.oilTankYear": "Oil Tank Year",
    "Profile_Dwellings_HeatingSystem.oilTankLocation": "Oil Tank Location",
    "Profile_Dwellings_HeatingSystem.year": "Year",
    "Profile_Dwellings_HeatingSystem.primary": "Primary",
    "Profile_Dwellings_HeatingSystem.renovationType": "Renovation Type",
    "Profile_Dwellings_HeatingSystem.renovationYear": "Renovation Year"
}
